import {AdminFeatureFlag, AdminFeatureFlags} from 'src/services/admin-feature-flag';

export const RECEIVE_FEATURE_FLAGS = 'ADMIN/RECEIVE_FEATURE_FLAGS';
export const ADD_OR_EDIT_FEATURE_FLAG = 'ADMIN/ADD_OR_EDIT_FEATURE_FLAG';
export const DELETE_FEATURE_FLAG = 'ADMIN/DELETE_FEATURE_FLAG';

export const receiveFeatureFlags = (featureFlags: AdminFeatureFlags) => ({
  type: RECEIVE_FEATURE_FLAGS,
  featureFlags,
});

export const addOrEditFeatureFlag = (featureFlag: AdminFeatureFlag) => ({
  type: ADD_OR_EDIT_FEATURE_FLAG,
  featureFlag,
});

export const deleteFeatureFlag = (id: string) => ({
  type: DELETE_FEATURE_FLAG,
  id,
});
